import { ExclamationCircleOutlined, VideoCameraTwoTone } from "@ant-design/icons";
import { Breadcrumb, Button, Empty, Modal, Pagination, Space, message } from "antd";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "../../common/utils";
import { Icon, Menu } from "../../components/index";
import no_class from "../../img/no_class.png";
import projectDefault from "../../img/project_default.jpg";
import project_bg from "../../img/project_bg.png";
import {
  checkSaleActivityTopicCourseExam,
  checkSaleActivityTopicExam,
  fetchSaleActivityProjectTopicCourseList,
  fetchSaleActivityProjectTopicInfo,
  getSaleActivityTopicCourseQuestionnaireUrl,
  getSaleActivityTopicExamPaperInfo,
  getSaleActivityTopicQuestionnaireUrl,
} from "./api";
import "../topicInfo/topicInfo.scss";
import "./activity.scss";

const QuestionStatus = ["不可以调查问卷", "可以调查问卷", "完成调查问卷"];
const ExamStatus = new Map([
  ["0", "学习进度未达标"],
  ["1", "可以考试"],
  ["2", "通过考试"],
  ["7", "未完成调查问卷"],
  ["8", "未考试"],
]);
const trainStatus = new Map([
  [0, "未通过"],
  [1, "未通过"],
  [2, "已通过"],
  [4, "未通过"],
  [7, "未通过"],
]);
const navList = [
  { title: "专题介绍", icon: "bullhorn" },
  { title: "课程列表", icon: "list-ul" },
  { title: "专题考试", icon: "landmark" },
];

const getFirstSectionId = (item: any) => {
  const section = item?.sectionList && item.sectionList[0];
  return section?.id || item?.sectionId;
};

export default function SaleActivityTopicInfo() {
  const query = useQuery();
  const history = useHistory();
  const saleActivityId = query.get("saleActivityId") || "";
  const projectId = query.get("projectId") || "";
  const topicId = query.get("topicId") || "";
  const [navIndex, setNavIndex] = useState("1");
  const [topicInfo, setTopicInfo] = useState<any>({});
  const [courseList, setCourseList] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 15;

  const loadTopicInfo = () => {
    fetchSaleActivityProjectTopicInfo({ saleActivityId, projectId, topicId }).then((res) => {
      const data = res.data || {};
      data.topicProgress = Number(parseFloat(data.topicProgress || 0));
      setTopicInfo(data);
    });
  };

  const loadCourseList = (currentPage = 1) => {
    fetchSaleActivityProjectTopicCourseList({
      saleActivityId,
      projectId,
      topicId,
      page: { currentPage, pageSize },
    }).then((res) => {
      const data = res.data || {};
      const list = (data.courseList || data.list || []).map((item: any) => ({
        ...item,
        topicId: item.topicId || topicId,
        progress: Number(item.progress || 0),
      }));
      setCourseList(list);
      setTotal(data.page?.totalResultSize || list.length || 0);
      setPage(data.page?.currentPage || currentPage);
    });
  };

  useEffect(() => {
    if (!saleActivityId || !projectId || !topicId) return;
    loadTopicInfo();
    loadCourseList(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saleActivityId, projectId, topicId]);

  const playCourse = (item: any) => {
    const sectionId = getFirstSectionId(item);
    if (!sectionId) {
      message.info("暂无可播放章节");
      return;
    }
    history.push(
      `/play?type=saleActivity&saleActivityId=${saleActivityId}&projectId=${projectId}&courseId=${item.courseId}&sectionId=${sectionId}&topicId=${topicId}&onlyPlay=1`
    );
  };

  const openLiveRoom = (item: any) => {
    const section = item.sectionList && item.sectionList[0];
    const { roomId, ccUserId } = section || {};
    if (!roomId || !ccUserId) {
      message.info("暂无直播地址");
      return;
    }
    window.open(`/shop/ccLiveFunction/getUserProjectLiveUrl?roomId=${roomId}&ccUserId=${ccUserId}&topicId=${topicId}`);
  };

  const jumpLiveRoom = (item: any) => {
    if (!item.sectionList || item.sectionList.length === 0) return;
    if (item.courseType === "live") {
      openLiveRoom(item);
      return;
    }
    playCourse(item);
  };

  const getCourseQuestionnaire = (item: any) => {
    const questionnaireStatus = item.questionnaireStatus;
    if (questionnaireStatus === 0 || questionnaireStatus === 2) {
      message.info(QuestionStatus[questionnaireStatus]);
      return;
    }
    getSaleActivityTopicCourseQuestionnaireUrl({
      saleActivityId,
      projectId,
      topicId,
      courseId: item.courseId,
    }).then((res) => {
      const url = res.data?.questionnaireUrl;
      if (url) window.location.href = url;
    });
  };

  const openCourseExam = (item: any) => {
    checkSaleActivityTopicCourseExam({
      saleActivityId,
      projectId,
      topicId,
      courseId: item.courseId,
    }).then((res) => {
      const data = res.data || {};
      if (data.courseCanExamNum === 0 && data.courseExamLimitFlag === 1) return;
      const { REACT_APP_BASE_URL, REACT_APP_EXAM_URL } = process.env;
      window.location.href = `${REACT_APP_BASE_URL}${REACT_APP_EXAM_URL}/exam-list/examList?fromType=saleActivityCourseExam&projectId=${projectId}&saleActivityId=${saleActivityId}&courseId=${item.courseId}&topicId=${topicId}`;
    });
  };

  const getTopicQuestionnaire = () => {
    const questionnaireStatus = topicInfo.topicQuestionnaireStatus;
    if (questionnaireStatus === 0 || questionnaireStatus === 2) {
      message.info(QuestionStatus[questionnaireStatus]);
      return;
    }
    getSaleActivityTopicQuestionnaireUrl({ saleActivityId, projectId, topicId }).then((res) => {
      const url = res.data?.questionnaireUrl;
      if (url) window.location.href = url;
    });
  };

  const openTopicExam = () => {
    checkSaleActivityTopicExam({ saleActivityId, projectId, topicId }).then((res) => {
      const data = res.data || {};
      const go = () => {
        if (data.topicCanExamNum === 0 && data.topicExamLimitFlag === 1) return;
        getSaleActivityTopicExamPaperInfo({ saleActivityId, projectId, topicId }).then(() => {
          const { REACT_APP_BASE_URL, REACT_APP_EXAM_URL } = process.env;
          window.location.href = `${REACT_APP_BASE_URL}${REACT_APP_EXAM_URL}/exam-list/examList?fromType=saleActivityTopicExam&projectId=${projectId}&saleActivityId=${saleActivityId}&topicId=${topicId}`;
        });
      };
      if (data.topicExamLimitFlag === 1) {
        Modal.confirm({
          title: "提示",
          icon: <ExclamationCircleOutlined />,
          content: (
            <div style={{ fontSize: "16px" }}>
              <p>
                本场共 <span style={{ fontSize: "24px", color: "red" }}>{data.topicExamLimitNum}</span> 次机会
              </p>
              <p>
                当前剩余 <span style={{ fontSize: "24px", color: "red" }}>{data.topicCanExamNum}</span> 次
              </p>
            </div>
          ),
          onOk: go,
        });
      } else {
        go();
      }
    });
  };

  const renderCourseList = () => {
    if (!courseList.length) {
      return (
        <div className="no_class">
          <img src={no_class} alt="暂无课程" />
          <p>暂无课程</p>
        </div>
      );
    }
    return (
      <>
        <div style={{ flex: 1 }}>
          {courseList.map((item, index) => (
            <div
              className={item.courseLock ? "topicCourseList_mask topicCourseList" : "topicCourseList"}
              key={`${item.courseId || index}-${topicId}`}
            >
              <h5
                onClick={() => jumpLiveRoom(item)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: item.sectionList?.length ? "pointer" : "default",
                }}
              >
                <VideoCameraTwoTone twoToneColor={item.courseType === "course" ? "" : "red"} />
                &emsp;
                <span style={{ color: "#1890ff" }}>{item.courseOrder || index + 1}</span>
                &emsp;
                <span dangerouslySetInnerHTML={{ __html: item.courseName || "--" }} />
              </h5>
              <div className="sale-activity-topic-course-row">
                <Space>
                  {item.courseDurationText !== "00:00:00" && <span>课程时长：{item.courseDurationText}</span>}
                  {Number(item.progress) > 0 && <span>学习进度：{item.progress}%</span>}
                  {topicInfo.showCourseExamStatusFlag === 1 &&
                    item.courseExamShowFlag === 1 &&
                    item.hasExamFlag === 1 &&
                    item.courseType === "course" && <span>练习状态:{trainStatus.get(item.examStatus)}</span>}
                </Space>
                <Space className="button_group">
                  {item.hasQuestionnaireFlag === 1 && (
                    <Button type="primary" size="small" onClick={() => getCourseQuestionnaire(item)}>
                      评价
                    </Button>
                  )}
                  {item.courseExamShowFlag === 1 && item.hasExamFlag === 1 && (
                    <Button
                      type="primary"
                      size="small"
                      disabled={item.examStatus === 0}
                      onClick={() => openCourseExam(item)}
                    >
                      练习
                    </Button>
                  )}
                  {item.sectionList?.length > 0 && (
                    <Button type="primary" size="small" onClick={() => jumpLiveRoom(item)}>
                      播放
                    </Button>
                  )}
                </Space>
              </div>
            </div>
          ))}
        </div>
        <div className="pagination-box">
          <h6>共{total}门课程</h6>
          <Pagination
            total={total}
            current={page}
            defaultPageSize={pageSize}
            showSizeChanger={false}
            onChange={(current) => loadCourseList(current)}
          />
        </div>
      </>
    );
  };

  return (
    <div className="projectInfo_box sale-activity-topic-info">
      <div className="project_header">
        <img className="header_img" src={project_bg} alt="" />
        <div className="project_title">
          <Breadcrumb separator="/" style={{ fontSize: "20px", marginBottom: "30px" }}>
            <Breadcrumb.Item href={`/#/saleActivityProjectInfo?saleActivityId=${saleActivityId}&projectId=${projectId}`}>
              培训主页
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>专题主页</span>
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="project_detail_box">
            <img
              src={topicInfo.topicPicture || projectDefault}
              alt=""
              style={{ width: "469px", height: "300px" }}
            />
            <div style={{ paddingLeft: "20px" }}>
              <h2>{topicInfo.topicName || "--"}</h2>
              <div className="time">
                {topicInfo.topicTimeRange && <p>开放时间：{topicInfo.topicTimeRange}</p>}
                <div>
                  {topicInfo.showCourseDurationFlag === 1 && topicInfo.topicDurationText !== "00:00:00" && (
                    <p style={{ width: "50%" }}>课程时长：{topicInfo.topicDurationText}</p>
                  )}
                  {topicInfo.showWatchTimeFlag === 1 && <p>已学时长：{topicInfo.topicWatchTimeText}</p>}
                </div>
                <div>
                  {topicInfo.showCourseCountFlag === 1 && (
                    <p style={{ width: "50%" }}>课程数量：{topicInfo.topicCourseCount || 0}</p>
                  )}
                  {topicInfo.showLearnedCourseCountFlag === 1 && (
                    <p>课程学完数量：{topicInfo.topicLearnedCourseCount || 0}</p>
                  )}
                </div>
                <div>
                  {topicInfo.showEvaluateCountFlag === 1 && (
                    <p style={{ width: "45%" }}>评分数量：{topicInfo.userEvaluateCount || 0}</p>
                  )}
                </div>
                <div>
                  {topicInfo.showCourseExamCountFlag === 1 && (
                    <p style={{ width: "50%" }}>练习数量：{topicInfo.topicCourseExamCount || 0}</p>
                  )}
                  {topicInfo.showFinishCourseExamCountFlag === 1 && (
                    <p>练习通过数量：{topicInfo.topicFinishCourseExamCount || 0}</p>
                  )}
                </div>
                <div>
                  {topicInfo.showLearnProgressFlag === 1 && (
                    <p style={{ width: "50%" }}>学习进度：{topicInfo.topicProgress || 0}%</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="project_list">
            <div>
              <Menu index={navIndex} defaultOpenSubMenus={[]} mode="horizontal" onSelect={(index) => setNavIndex(index)}>
                {navList.map((it, index) => (
                  <Menu.Item key={index}>
                    <Icon icon={it.icon as any} size="1x" theme="dark" style={{ marginRight: "8px" }} />
                    <span>{it.title}</span>
                  </Menu.Item>
                ))}
              </Menu>
              <div className="video_box">
                {navIndex === "0" &&
                  (topicInfo.intro ? (
                    <div dangerouslySetInnerHTML={{ __html: topicInfo.intro }} />
                  ) : (
                    <Empty description="暂无专题介绍" />
                  ))}
                {navIndex === "1" && renderCourseList()}
                {navIndex === "2" && (
                  <div className="examInfo_box">
                    {topicInfo.hasTopicQuestionnaireFlag === 1 && (
                      <div>
                        <p>项目问卷</p>
                        <p style={{ display: "flex", justifyContent: "space-between" }}>
                          <span>状态：{QuestionStatus[topicInfo.topicQuestionnaireStatus]}</span>
                          <Button
                            type="primary"
                            disabled={
                              topicInfo.topicQuestionnaireStatus === 0 ||
                              topicInfo.topicQuestionnaireStatus === 2
                            }
                            onClick={getTopicQuestionnaire}
                          >
                            进入问卷
                          </Button>
                        </p>
                      </div>
                    )}
                    {topicInfo.hasTopicExamFlag === 1 && (
                      <div>
                        <p>{topicInfo.topicExamName || "专题考试"}</p>
                        <p style={{ display: "flex", justifyContent: "space-between" }}>
                          <span>状态：{ExamStatus.get(String(topicInfo.topicExamStatus)) || "--"}</span>
                          <Button
                            type="primary"
                            disabled={
                              topicInfo.topicExamStatus === 0 ||
                              topicInfo.topicExamStatus === 10 ||
                              topicInfo.topicExamStatus === 6 ||
                              topicInfo.topicExamStatus === 7
                            }
                            onClick={openTopicExam}
                          >
                            进入考试
                          </Button>
                        </p>
                      </div>
                    )}
                    {topicInfo.hasTopicQuestionnaireFlag !== 1 && topicInfo.hasTopicExamFlag !== 1 && (
                      <div className="no_class">
                        <img src={no_class} alt="暂无相关信息" />
                        <p>暂无相关信息</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
